module.exports = __webpack_public_path__ + "img/money-tag2.0c8a6d7d.webp";